import { render, staticRenderFns } from "./ContactSearch.vue?vue&type=template&id=3b3764a6"
import script from "./ContactSearch.vue?vue&type=script&lang=js"
export * from "./ContactSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports